import React from "react";

export function Skeleton({ className = "" }) {
  return <div className={`skeleton ${className}`} aria-hidden="true" />;
}

export function ProductCardSkeleton() {
  return (
    <div data-testid="product-skeleton">
      <Skeleton className="aspect-[3/4] w-full rounded-t-[38%] rounded-b-2xl" />
      <Skeleton className="mt-4 h-6 w-3/4 rounded" />
      <Skeleton className="mt-2 h-4 w-1/3 rounded" />
    </div>
  );
}
